import { apiServiceClient } from '../frameworkClient';

const posaleServiceClient = apiServiceClient(
  process.env.REACT_APP_POSALE_URL || 'framework/PosaleService',
);

const endpoints = {
  addDevice: 'addDevice',
  addDeviceReferenceToCart: 'addDeviceReferenceToCart',
  addDiscount: 'addDiscount',
  addExtra: 'addExtra',
  addExtraManually: 'addExtraManually',
  addManualItem: 'addManualItem',
  addParentDevice: 'addParentDevice',
  addSerialNumbers: 'addSerialNumbers',
  addToCart: 'addToCart',
  amendDeviceCode: 'amendDeviceCode',
  amendDeviceReference: 'amendDeviceReference',
  cancelCmrOrder: 'cancelCmrOrder',
  cancelOrder: 'cancelOrder',
  cancelSale: 'cancelSale',
  cancelUpgrade: 'cancelUpgrade',
  changeExtraQuantity: 'changeExtraQuantity',
  changeOrderPP: 'changeOrderPP',
  changePassword: 'changePassword',
  changeOrderPaymentPlan: 'changeOrderPaymentPlan',
  changeProductQuantity: 'changeProductQuantity',
  changeSalePrice: 'changeSalePrice',
  changeSelectedStore: 'changeSelectedStore',
  clearCollectionTimes: 'clearCollectionTimes',
  clearDiagnostic: 'clearDiagnostic',
  clearRecycle: 'clearRecycle',
  clearSelectedProduct: 'clearSelectedProduct',
  companyLookup: 'companyLookup',
  clearSelections: 'clearSelections',
  createCart: 'createCart',
  createMultiTradecart: 'createMultiTradecart',
  createNewCollection: 'createNewCollection',
  createRecycleCart: 'createRecycleCart',
  createTradecart: 'createTradecart',
  deleteRule: 'deleteRule',
  evaluateDevice: 'evaluateDevice',
  export: 'export',
  finaliseCart: 'finaliseCart',
  fulfillmentReturn: 'fulfillmentReturn',
  finalizeMultiRecycle: 'finalizeMultiRecycle',
  forgotPassword: 'forgotPassword',
  getAmendDeviceCodeList: 'getAmendDeviceCodeList',
  getCartActions: 'getCartActions',
  getCartInvoices: 'getCartInvoices',
  getCollectionDetails: 'getCollectionDetails',
  getCollectionFormInfo: 'getCollectionFormInfo',
  getCollections: 'getCollections',
  getCollectionTimes: 'getCollectionTimes',
  getCollectors: 'getCollectors',
  getCollectorsRules: 'getCollectorsRules',
  getCompanyDetailsFormData: 'getCompanyDetailsFormData',
  getCriteria: 'getCriteria',
  getCustomer: 'getCustomer',
  getDeviceList: 'getDeviceList',
  getExtrasCategories: 'getExtrasCategories',
  getOnlineTradeinQuote: 'getOnlineTradeinQuote',
  getPricedExtras: 'getPricedExtras',
  getProductCategories: 'getProductCategories',
  getProductFamilies: 'getProductFamilies',
  getRecyclePoliceReport: 'getRecyclePoliceReport',
  getRecycleReceipt: 'getRecycleReceipt',
  getReports: 'getReports',
  getReturnedDevices: 'getReturnedDevices',
  getRuleTableData: 'getRuleTableData',
  getRuleTableMetaData: 'getRuleTableMetaData',
  getSale: 'getSale',
  getSales: 'getSales',
  getServices: 'getServices',
  getSettlements: 'getSettlements',
  getStartingInfo: 'getStartingInfo',
  getTradecartStatus: 'getTradecartStatus',
  getUserInfo: 'getUserInfo',
  listRecycleOrders: 'listRecycleOrders',
  login: 'login',
  logout: 'logout',
  removeCurrentCart: 'removeCurrentCart',
  removeDevice: 'removeDevice',
  removeDiscount: 'removeDiscount',
  removeExtra: 'removeExtra',
  removeOrder: 'removeOrder',
  removeParentDevice: 'removeParentDevice',
  removeProduct: 'removeProduct',
  resetPassword: 'resetPassword',
  returnDevice: 'returnDevice',
  revalidateDeviceReference: 'revalidateDeviceReference',
  saveCart: 'saveCart',
  saveCurrentCart: 'saveCurrentCart',
  saveDeviceReference: 'saveDeviceReference',
  saveEvaluationAnswer: 'saveEvaluationAnswer',
  saveFinancingType: 'saveFinancingType',
  saveRule: 'saveRule',
  saveSelectedCategory: 'saveSelectedCategory',
  saveSelectedDevice: 'saveSelectedDevice',
  saveSelectedExtraOption: 'saveSelectedExtraOption',
  saveSelectedFamily: 'saveSelectedFamily',
  saveSelectedInsurance: 'saveSelectedInsurance',
  saveSelectedPP: 'saveSelectedPP',
  searchDevices: 'searchDevices',
  searchOnlineTradeinQuotes: 'searchOnlineTradeinQuotes',
  selectDevicePromotion: 'selectDevicePromotion',
  selectOption: 'selectOption',
  selectPromotion: 'selectPromotion',
  selectRecycleDevice: 'selectRecycleDevice',
  selectRecycleNetworkStatus: 'selectRecycleNetworkStatus',
  selectRecycleOutcome: 'selectRecycleOutcome',
  sendQuoteApprovalMessage: 'sendQuoteApprovalMessage',
  setDeviceReference: 'setDeviceReference',
  setDeviceSimStatus: 'setDeviceSimStatus',
  setDiagnostic: 'setDiagnostic',
  setRecycleType: 'setRecycleType',
  setSearchDeviceReference: 'setSearchDeviceReference',
  setSelectedPaymentPlan: 'setSelectedPaymentPlan',
  setSelectedService: 'setSelectedService',
  singleSignOn: 'singleSignOn',
  updateResellerServices: 'updateResellerServices',
  updateSelectedProduct: 'updateSelectedProduct',
  validateDeviceReference: 'validateDeviceReference',
  withdraw: 'withdraw',
};

export const addDevice = async ({ device, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.addDevice,
    { device, sessionID },
    options,
  );
};

export const addDeviceReferenceToCart = async (
  { cartUUID, deviceReference, isIMEI, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.addDeviceReferenceToCart,
    {
      cartUUID,
      deviceReference,
      isIMEI,
      sessionID,
    },
    options,
  );
};

export const addDiscount = async (
  { orderUUID, typeID, value, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.addDiscount,
    { orderUUID, typeID, value, sessionID },
    options,
  );
};

export const addExtra = async ({ cartUUID, extraCode, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.addExtra,
    { cartUUID, extraCode, sessionID },
    options,
  );
};

export const addExtraManually = async (
  { cartUUID, values, isCTO, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.addExtraManually,
    { cartUUID, values, isCTO, sessionID },
    options,
  );
};

export const addManualItem = async ({ cartUUID, item, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.addManualItem,
    { cartUUID, item, sessionID },
    options,
  );
};

export const addParentDevice = async ({ cartUUID, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.addParentDevice,
    { cartUUID, sessionID },
    options,
  );
};

export const addSerialNumbers = async (
  { cartUUID, serialNumbers, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.addSerialNumbers,
    { cartUUID, serialNumbers, sessionID },
    options,
  );
};

export const addToCart = async (
  { cartUUID, showNotification, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.addToCart,
    { cartUUID, showNotification, sessionID },
    options,
  );
};

export const cancelCmrOrder = async (
  { tradecartID, reason, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.cancelCmrOrder,
    {
      tradecartID,
      reason,
      sessionID,
    },
    options,
  );
};

export const amendDeviceCode = async (
  { orderUUID, newDeviceCode, newReference, isIMEI, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.amendDeviceCode,
    { orderUUID, newDeviceCode, newReference, isIMEI, sessionID },
    options,
  );
};

export const amendDeviceReference = async (
  { orderUUID, newReference, isIMEI, sessionID },
  options,
) =>
  posaleServiceClient(
    endpoints.amendDeviceReference,
    { orderUUID, newReference, isIMEI, sessionID },
    options,
  );

export const cancelOrder = async ({ orderUUID, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.cancelOrder,
    { orderUUID, sessionID },
    options,
  );
};

export const cancelSale = async ({ cartUUID, sessionID }, options) =>
  posaleServiceClient(endpoints.cancelSale, { cartUUID, sessionID }, options);

export const cancelUpgrade = async ({ orderUUID, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.cancelUpgrade,
    { orderUUID, sessionID },
    options,
  );
};

export const changeExtraQuantity = async (
  { cartUUID, extraUUID, quantity, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.changeExtraQuantity,
    { cartUUID, extraUUID, quantity, sessionID },
    options,
  );
};

export const changeOrderPP = async (
  { cartUUID, paymentplanID, selectedService, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.changeOrderPP,
    { cartUUID, paymentplanID, selectedService, sessionID },
    options,
  );
};

export const changePassword = async (
  { oldPassword, newPassword, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.changePassword,
    {
      oldPassword,
      newPassword,
      sessionID,
    },
    options,
  );
};

export const changeOrderPaymentPlan = async (
  { cartUUID, sessionID },
  options,
) =>
  posaleServiceClient(
    endpoints.changeOrderPaymentPlan,
    { cartUUID, sessionID },
    options,
  );

export const changeProductQuantity = async (
  { cartUUID, productUUID, quantity, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.changeProductQuantity,
    { cartUUID, productUUID, quantity, sessionID },
    options,
  );
};

export const changeSalePrice = async (
  { cartUUID, UUID, salePrice, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.changeSalePrice,
    { cartUUID, UUID, salePrice, sessionID },
    options,
  );
};

export const changeSelectedStore = async (
  { storeID, cartUUID, sessionID },
  options,
) =>
  posaleServiceClient(
    endpoints.changeSelectedStore,
    { storeID, cartUUID, sessionID },
    options,
  );

export const clearCollectionTimes = async ({ sessionID }, options) => {
  return posaleServiceClient(
    endpoints.clearCollectionTimes,
    { sessionID },
    options,
  );
};

export const clearDiagnostic = async ({ sessionID }, options) => {
  return posaleServiceClient(endpoints.clearDiagnostic, { sessionID }, options);
};

export const clearRecycle = async ({ sessionID }, options) => {
  return posaleServiceClient(endpoints.clearRecycle, { sessionID }, options);
};

export const clearSelectedProduct = async (
  { cartUUID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.clearSelectedProduct,
    { cartUUID, sessionID },
    options,
  );
};

export const companyLookup = async (
  { cartUUID, searchString = '', location = '', sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.companyLookup,
    { cartUUID, searchString, location, sessionID },
    options,
  );
};

export const clearSelections = async ({ sessionID }, options) => {
  return posaleServiceClient(endpoints.clearSelections, { sessionID }, options);
};

export const createCart = async ({ tradecartID, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.createCart,
    { tradecartID, sessionID },
    options,
  );
};

export const createMultiTradecart = async (
  { ustomer, selectedDevices, selectedOutcome, orderUUID, service, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.createMultiTradecart,
    {
      ustomer,
      selectedDevices,
      selectedOutcome,
      orderUUID,
      service,
      sessionID,
    },
    options,
  );
};

export const createNewCollection = async (
  {
    address,
    boxCount,
    collector,
    selectedDevices,
    totalWeight,
    collectionDate,
    collectionTimeSlotCode,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.createNewCollection,
    {
      address,
      boxCount,
      collector,
      selectedDevices,
      totalWeight,
      collectionDate,
      collectionTimeSlotCode,
      sessionID,
    },
    options,
  );
};

export const createRecycleCart = async (
  { recycleCart, recycleType, service, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.createRecycleCart,
    { recycleCart, recycleType, service, sessionID },
    options,
  );
};

export const createTradecart = async (
  { selectedDevice, orderGUID, recycle, service, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.createTradecart,
    { selectedDevice, orderGUID, recycle, service, sessionID },
    options,
  );
};

export const deleteRule = async (
  { sessionID, ruleID, ruleTableIdentifier },
  options,
) => {
  return posaleServiceClient(
    endpoints.deleteRule,
    {
      sessionID,
      ruleTableIdentifier,
      ruleID,
    },
    options,
  );
};

export const evaluateDevice = async (
  {
    additionAnswers,
    categoryCode,
    criteriaAnswers,
    deductionAnswers,
    deviceCode,
    deviceID,
    grade,
    manufacturerCode,
    networkStatus,
    orderGUID,
    orderUUID,
    priceID,
    promotionID,
    tradecartID,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.evaluateDevice,
    {
      additionAnswers,
      categoryCode,
      criteriaAnswers,
      deductionAnswers,
      deviceCode,
      deviceID,
      grade,
      manufacturerCode,
      networkStatus,
      orderGUID,
      orderUUID,
      priceID,
      promotionID,
      tradecartID,
      sessionID,
    },
    options,
  );
};

export const exportDocument = async (
  { entity, filters, format, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.export,
    {
      entity,
      filters,
      format,
      sessionID,
    },
    options,
  );
};

export const finaliseCart = async ({ cartUUID, sessionID }, options) =>
  posaleServiceClient(endpoints.finaliseCart, { cartUUID, sessionID }, options);

export const fulfillmentReturn = async (
  {
    cartUUID,
    fulfillmentReturnType,
    returnReasonCode,
    conditionDescription,
    sessionID,
  },
  options,
) =>
  posaleServiceClient(
    endpoints.fulfillmentReturn,
    {
      cartUUID,
      fulfillmentReturnType,
      returnReasonCode,
      conditionDescription,
      sessionID,
    },
    options,
  );

export const finalizeMultiRecycle = async (
  {
    recycleCart,
    selectedDevices,
    selectedOutcome,
    orderUUID,
    customer,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.finalizeMultiRecycle,
    {
      recycleCart,
      selectedDevices,
      selectedOutcome,
      orderUUID,
      customer,
      sessionID,
    },
    options,
  );
};

export const forgotPassword = async ({ login }, options) => {
  return posaleServiceClient(endpoints.forgotPassword, { login }, options);
};

export const getAmendDeviceCodeList = async (
  { orderUUID, sessionID },
  options,
) =>
  posaleServiceClient(
    endpoints.getAmendDeviceCodeList,
    { orderUUID, sessionID },
    options,
  );

export const getCartActions = async ({ cartUUID, sessionID }, options) =>
  posaleServiceClient(
    endpoints.getCartActions,
    { cartUUID, sessionID },
    options,
  );

export const getCartInvoices = async ({ cartUUID, sessionID }, options) => {
  const response = await posaleServiceClient(
    endpoints.getCartInvoices,
    { cartUUID, sessionID },
    options,
  );
  return {
    ...response,
    data: {
      ...response.data,
      cartInvoices: response.data.cartInvoices
        .sort((a, b) => b.id - a.id)
        .map((invoice) => ({
          ...invoice,
          items: invoice.items.map((item) => ({
            description: item.description,
            id: `${invoice.id}-${item.id}`,
            partNumber: item.partNumber,
            quantity: item.quantity,
            serialNumbers: item.serialNumbers,
            deliveryNumber: invoice.deliveryNumber,
            orderReference: invoice.orderReference,
            currencyCode: invoice.currencyCode,
            invoiceAmountInclTax: invoice.invoiceAmountInclTax,
            taxAmount: invoice.taxAmount,
            createdAt: invoice.createdAt,
          })),
        })),
    },
  };
};

export const getCollectionDetails = async (
  { collectionUUID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.getCollectionDetails,
    { collectionUUID, sessionID },
    options,
  );
};

export const getCollectionFormInfo = async (
  { storeID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.getCollectionFormInfo,
    { storeID, sessionID },
    options,
  );
};

export const getCollections = async (
  { collector, startDate, endDate, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.getCollections,
    { collector, startDate, endDate, sessionID },
    options,
  );
};

export const getCollectionTimes = async (
  { countryCode, postalCode, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.getCollectionTimes,
    { countryCode, postalCode, sessionID },
    options,
  );
};

export const getCollectors = async ({ sessionID }, options) => {
  return posaleServiceClient(endpoints.getCollectors, { sessionID }, options);
};

export const getCollectorsRules = async ({ sessionID }, options) => {
  return posaleServiceClient(
    endpoints.getCollectorsRules,
    { sessionID },
    options,
  );
};

export const getCompanyDetailsFormData = async (
  { cartUUID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.getCompanyDetailsFormData,
    { cartUUID },
    options,
  );
};

export const getCriteria = async ({ selectedDevice, sessionID }, options) =>
  posaleServiceClient(
    endpoints.getCriteria,
    {
      ...selectedDevice,
      sessionID,
    },
    options,
  );

export const getCustomer = async ({ customerUUID, sessionID }, options) => {
  return posaleServiceClient(endpoints.getCustomer, { customerUUID }, options);
};

export const getDeviceList = async ({
  sessionID,
  manufacturer,
  category,
  family,
  searchType,
}) => {
  return posaleServiceClient(endpoints.getDeviceList, {
    sessionID,
    manufacturer,
    category,
    family,
    onlyEnabled: true,
    onlyEnabledForUpgrade: false,
    searchType,
  });
};

export const getExtrasCategories = async ({ sessionID }, options) => {
  return posaleServiceClient(
    endpoints.getExtrasCategories,
    { sessionID },
    options,
  );
};

export const getOnlineTradeinQuote = async (
  { tradecartSID, sessionID },
  options,
) =>
  posaleServiceClient(
    endpoints.getOnlineTradeinQuote,
    { tradecartSID, sessionID },
    options,
  );

export const getPricedExtras = async (
  {
    cartUUID,
    deviceCode,
    parentDeviceCode,
    updateExtrasPrice,
    searchText,
    page,
    category,
    quantity,
    isDeviceOnly,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.getPricedExtras,
    {
      cartUUID,
      deviceCode,
      parentDeviceCode,
      updateExtrasPrice,
      searchText,
      page,
      category,
      quantity,
      isDeviceOnly,
      sessionID,
    },
    options,
  );
};

export const getProductCategories = async (
  {
    financingType,
    paymentplanID,
    tagFilterList,
    tagFilterType,
    serviceName,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.getProductCategories,
    {
      financingType,
      paymentplanID,
      tagFilterList,
      tagFilterType,
      serviceName,
      sessionID,
    },
    options,
  );
};

export const getProductFamilies = async (
  {
    categoryCode,
    financingType,
    paymentplanID,
    tagFilterList: tags,
    tagFilterType,
    searchText,
    page,
    quantity,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.getProductFamilies,
    {
      categoryCode,
      financingType,
      paymentplanID,
      tagFilterList: tags,
      tagFilterType,
      searchText,
      page,
      quantity,
      sessionID,
    },
    options,
  );
};

export const getRecyclePoliceReport = async (
  { startDate, endDate, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.getRecyclePoliceReport,
    { startDate, endDate, sessionID },
    options,
  );
};

export const getRecycleReceipt = ({ id, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.getRecycleReceipt,
    {
      id,
      sessionID,
    },
    options,
  );
};

export const getReports = async (
  {
    contractStatus,
    financingType,
    onlySalesWithPendingActions,
    activeForm,
    contractPeriod,
    startDate,
    endDate,
    storeID,
    dateRange,
    customerEmail,
    customerPhone,
    searchText,
    page,
    quantity,
    timestamp,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.getReports,
    {
      contractStatus,
      financingType,
      onlySalesWithPendingActions,
      activeForm,
      contractPeriod,
      startDate,
      endDate,
      storeID,
      dateRange,
      customerEmail,
      customerPhone,
      searchText,
      page,
      quantity,
      timestamp,
      sessionID,
    },
    options,
  );
};

export const getReturnedDevices = async (
  { collector, startDate, endDate, imei, showCollected, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.getReturnedDevices,
    { collector, startDate, endDate, imei, showCollected, sessionID },
    options,
  );
};

export const getRuleTableData = async ({ sessionID, ruleTableIdentifier }) => {
  return posaleServiceClient(endpoints.getRuleTableData, {
    sessionID,
    ruleTableIdentifier,
  });
};

export const getRuleTableMetaData = async ({
  sessionID,
  ruleTableIdentifier,
}) => {
  return posaleServiceClient(endpoints.getRuleTableMetaData, {
    sessionID,
    ruleTableIdentifier,
  });
};

export const getSale = async ({ cartUUID, sessionID }, options) =>
  posaleServiceClient(endpoints.getSale, { cartUUID, sessionID }, options);

export const getSales = async (
  { onlySalesWithPendingActions, filter, search, sessionID },
  options,
) =>
  posaleServiceClient(
    endpoints.getSales,
    { onlySalesWithPendingActions, filter, search, sessionID },
    options,
  );

export const getServices = async (
  { tradecartID, selectedOutcome, sessionID },
  options,
) =>
  posaleServiceClient(
    endpoints.getServices,
    { tradecartID, selectedOutcome, sessionID },
    options,
  );

export const getSettlements = async (
  { startDate, endDate, offset, size, sessionID },
  options,
) =>
  posaleServiceClient(
    endpoints.getSettlements,
    { startDate, endDate, offset, size, sessionID },
    options,
  );

export const getStartingInfo = async (emptyPayload, options) =>
  posaleServiceClient(endpoints.getStartingInfo, emptyPayload, options);

export const getTradecartStatus = async ({ sessionID }, options) => {
  return posaleServiceClient(
    endpoints.getTradecartStatus,
    { sessionID },
    options,
  );
};

export const getUserInfo = async ({ token }, options) =>
  posaleServiceClient(endpoints.getUserInfo, { token }, options);

export const listRecycleOrders = async (
  { startDate, endDate, orderStatus, orderID, deviceReference, sessionID },
  options,
) =>
  posaleServiceClient(
    endpoints.listRecycleOrders,
    { startDate, endDate, orderStatus, orderID, deviceReference, sessionID },
    options,
  );

export const login = async ({ login, password, sessionID }, options) =>
  posaleServiceClient(endpoints.login, { login, password, sessionID }, options);

export const logout = async ({ sessionID }, options) =>
  posaleServiceClient(endpoints.logout, { sessionID }, options);

export const removeCurrentCart = async ({ sessionID }, options) => {
  return posaleServiceClient(
    endpoints.removeCurrentCart,
    { sessionID },
    options,
  );
};

export const removeDevice = async ({ id, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.removeDevice,
    { id, sessionID },
    options,
  );
};

export const removeDiscount = async (
  { orderUUID, discountUUID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.removeDiscount,
    { orderUUID, discountUUID, sessionID },
    options,
  );
};
export const removeExtra = async (
  { orderUUID, extraUUID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.removeExtra,
    { orderUUID, extraUUID, sessionID },
    options,
  );
};

export const removeOrder = async ({ orderUUID, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.removeOrder,
    { orderUUID, sessionID },
    options,
  );
};

export const removeParentDevice = async ({ cartUUID, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.removeParentDevice,
    { cartUUID, sessionID },
    options,
  );
};

export const removeProduct = async (
  { orderUUID, productUUID, fetchPaymentPlans, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.removeProduct,
    { orderUUID, productUUID, fetchPaymentPlans, sessionID },
    options,
  );
};

export const resetPassword = async ({ resetToken }, options) =>
  posaleServiceClient(endpoints.resetPassword, { resetToken }, options);

export const returnDevice = async (
  { recycleCart, type, customer, service, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.returnDevice,
    { recycleCart, type, customer, service, sessionID },
    options,
  );
};

export const revalidateDeviceReference = async (
  {
    deviceReference,
    referenceType,
    orderGUID,
    orderUUID,
    searchText,
    deviceID,
    device,
    isMultiTrade,
    service,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.revalidateDeviceReference,
    {
      deviceReference,
      referenceType,
      orderGUID,
      orderUUID,
      searchText,
      deviceID,
      device,
      isMultiTrade,
      service,
      sessionID,
    },
    options,
  );
};

export const saveCart = async ({ cart, sessionID }, options) => {
  return posaleServiceClient(endpoints.saveCart, { cart, sessionID }, options);
};

export const saveCurrentCart = async ({ cartUUID, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.saveCurrentCart,
    { cartUUID, sessionID },
    options,
  );
};

export const saveDeviceReference = async (
  { deviceReference, referenceType, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.saveDeviceReference,
    { deviceReference, referenceType, sessionID },
    options,
  );
};

export const saveEvaluationAnswer = async (
  {
    question,
    answer,
    type,
    orderUUID,
    orderGUID,
    selectedDevice,
    selectedSIMStatus,
    service,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.saveEvaluationAnswer,
    {
      question,
      answer,
      type,
      orderUUID,
      orderGUID,
      selectedDevice,
      selectedSIMStatus,
      service,
      sessionID,
    },
    options,
  );
};

export const saveFinancingType = async (
  { cartUUID, financingType, tags, tagFilterType, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.saveFinancingType,
    { cartUUID, financingType, tags, tagFilterType, sessionID },
    options,
  );
};

export const saveRule = async (
  { sessionID, data, ruleTableIdentifier },
  options,
) => {
  return posaleServiceClient(
    endpoints.saveRule,
    {
      sessionID,
      data,
      ruleTableIdentifier,
    },
    options,
  );
};

export const saveSelectedCategory = async (
  { cartUUID, id, categoryName, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.saveSelectedCategory,
    { cartUUID, id, name: categoryName, sessionID },
    options,
  );
};

export const saveSelectedDevice = async (
  { cartUUID, payload, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.saveSelectedDevice,
    { cartUUID, payload, sessionID },
    options,
  );
};

export const saveSelectedExtraOption = async (
  { cartUUID, selectedExtraOptionID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.saveSelectedExtraOption,
    { cartUUID, selectedExtraOptionID, sessionID },
    options,
  );
};

export const saveSelectedFamily = async (
  {
    cartUUID,
    deviceCode,
    insuranceID,
    paymentplanID,
    subscriptionID,
    hasCTOs,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.saveSelectedFamily,
    {
      cartUUID,
      deviceCode,
      insuranceID,
      paymentplanID,
      subscriptionID,
      hasCTOs,
      sessionID,
    },
    options,
  );
};

export const saveSelectedInsurance = async (
  { cartUUID, insuranceID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.saveSelectedInsurance,
    { cartUUID, insuranceID, sessionID },
    options,
  );
};

export const saveSelectedPP = async (
  {
    cartUUID,
    paymentplanID,
    updateExtras,
    deviceCode,
    parentDeviceCode,
    updateExtrasPrice,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.saveSelectedPP,
    {
      cartUUID,
      paymentplanID,
      updateExtras,
      deviceCode,
      parentDeviceCode,
      updateExtrasPrice,
      sessionID,
    },
    options,
  );
};

export const searchDevices = async (
  { deviceReference, referenceType, searchText, orderUUID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.searchDevices,
    { deviceReference, referenceType, searchText, orderUUID, sessionID },
    options,
  );
};

export const searchOnlineTradeinQuotes = async (
  { searchText, searchType, sessionID },
  options,
) =>
  posaleServiceClient(
    endpoints.searchOnlineTradeinQuotes,
    { searchText, searchType, sessionID },
    options,
  );

export const selectDevicePromotion = async (
  { deviceID, promotionID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.selectDevicePromotion,
    { deviceID, promotionID, sessionID },
    options,
  );
};
export const selectOption = async ({ cartUUID, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.selectOption,
    { cartUUID, sessionID },
    options,
  );
};

export const selectPromotion = async ({ promotionID, sessionID }, options) => {
  return posaleServiceClient(
    endpoints.selectPromotion,
    { promotionID, sessionID },
    options,
  );
};

export const selectRecycleDevice = async (
  {
    selectedDevice,
    networkLockStatus,
    selectedSIMStatus,
    orderGUID,
    orderUUID,
    service,
    sessionID,
  },
  options,
) => {
  return posaleServiceClient(
    endpoints.selectRecycleDevice,
    {
      selectedDevice,
      networkLockStatus,
      selectedSIMStatus,
      orderGUID,
      orderUUID,
      service,
      sessionID,
    },
    options,
  );
};

export const selectRecycleNetworkStatus = async (
  { selectedSIMStatus, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.selectRecycleNetworkStatus,
    { selectedSIMStatus, sessionID },
    options,
  );
};

export const selectRecycleOutcome = async (
  { newOutcome, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.selectRecycleOutcome,
    { newOutcome, sessionID },
    options,
  );
};

export const sendQuoteApprovalMessage = async (
  { tradecartId, distributionMethod, service, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.sendQuoteApprovalMessage,
    { tradecartId, distributionMethod, service, sessionID },
    options,
  );
};

export const setDeviceReference = async (
  { deviceReference, referenceType, id, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.setDeviceReference,
    { deviceReference, referenceType, id, sessionID },
    options,
  );
};

export const setDeviceSimStatus = async (
  { id, selectedNetworkLockStatus, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.setDeviceSimStatus,
    { id, selectedNetworkLockStatus, sessionID },
    options,
  );
};

export const setDiagnostic = async (
  { diagnosticString, selectedDevice, selectedSIMStatus, orderUUID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.setDiagnostic,
    {
      diagnosticString,
      selectedDevice,
      selectedSIMStatus,
      orderUUID,
      sessionID,
    },
    options,
  );
};

export const setRecycleType = async (
  { recycleType, orderUUID, funder, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.setRecycleType,
    { recycleType, orderUUID, funder, sessionID },
    options,
  );
};

export const setSearchDeviceReference = async (
  { deviceReference, referenceType, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.setSearchDeviceReference,
    { deviceReference, referenceType, sessionID },
    options,
  );
};
export const setSelectedPaymentPlan = async (
  { cartUUID, paymentplanID, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.setSelectedPaymentPlan,
    { cartUUID, paymentplanID, sessionID },
    options,
  );
};

export const setSelectedService = async (
  { cartUUID, service, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.setSelectedService,
    { cartUUID, service, sessionID },
    options,
  );
};

export const singleSignOn = async (emptyPayload, options) =>
  posaleServiceClient(endpoints.singleSignOn, emptyPayload, options);

export const updateResellerServices = async (
  { cartUUID, sessionID },
  options,
) =>
  posaleServiceClient(
    endpoints.updateResellerServices,
    { cartUUID, sessionID },
    options,
  );

export const updateSelectedProduct = async (
  { cartUUID, changes, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.updateSelectedProduct,
    { cartUUID, changes, sessionID },
    options,
  );
};

export const validateDeviceReference = async (
  { deviceReference, referenceType, orderUUID, searchText, sessionID },
  options,
) => {
  return posaleServiceClient(
    endpoints.validateDeviceReference,
    {
      orderUUID,
      isIMEI: referenceType === 'IMEI',
      deviceReference,
      searchText,
      fetchModelData: false,
      sessionID,
    },
    options,
  );
};

export const withdraw = async ({ cartUUID, sessionID }, options) =>
  posaleServiceClient(endpoints.withdraw, { cartUUID, sessionID }, options);

export default {
  addDevice,
  addDeviceReferenceToCart,
  addSerialNumbers,
  amendDeviceCode,
  amendDeviceReference,
  cancelCmrOrder,
  cancelOrder,
  cancelSale,
  cancelUpgrade,
  changePassword,
  changeOrderPaymentPlan,
  changeSelectedStore,
  clearCollectionTimes,
  clearDiagnostic,
  clearRecycle,
  clearSelections,
  createMultiTradecart,
  createNewCollection,
  createRecycleCart,
  createTradecart,
  deleteRule,
  endpoints,
  evaluateDevice,
  evaluateDevice,
  export: exportDocument,
  finaliseCart,
  fulfillmentReturn,
  finalizeMultiRecycle,
  forgotPassword,
  getAmendDeviceCodeList,
  getCartActions,
  getCartInvoices,
  getCollectionDetails,
  getCollectionFormInfo,
  getCollections,
  getCollectionTimes,
  getCollectors,
  getCollectorsRules,
  getCriteria,
  getDeviceList,
  getExtrasCategories,
  getOnlineTradeinQuote,
  getProductCategories,
  getProductFamilies,
  getRecyclePoliceReport,
  getRecycleReceipt,
  getReports,
  getReturnedDevices,
  getRuleTableData,
  getRuleTableMetaData,
  getSale,
  getSales,
  getServices,
  getSettlements,
  getStartingInfo,
  getTradecartStatus,
  getUserInfo,
  listRecycleOrders,
  login,
  logout,
  removeDevice,
  resetPassword,
  returnDevice,
  revalidateDeviceReference,
  saveDeviceReference,
  saveEvaluationAnswer,
  saveRule,
  searchDevices,
  searchOnlineTradeinQuotes,
  selectDevicePromotion,
  selectPromotion,
  selectRecycleDevice,
  selectRecycleNetworkStatus,
  selectRecycleOutcome,
  sendQuoteApprovalMessage,
  setDeviceReference,
  setDeviceSimStatus,
  setDiagnostic,
  setRecycleType,
  setSearchDeviceReference,
  singleSignOn,
  updateResellerServices,
  validateDeviceReference,
  validateDeviceReference,
  withdraw,
};
